<template>
  <div class="c-rulebox-w" @click.self="close" v-show="boxShow">
    <div class="c-rulebox">
      <div class="c-rulebox__tit">{{ $t('activity_rule') }}</div>
      <div class="c-rulebox__content">{{ $t('_invite_activity_rule') }}</div>
      <div class="c-rulebox__btn" @click="close">
        {{ $t('i_know') }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      boxShow: false,
      scrollTop: 0
    };
  },
  methods: {
    close() {
      this.boxShow = false;
      $('html,body')
        .css('overflow', 'auto')
        .scrollTop(this.scrollTop);
    },
    show() {
      this.boxShow = true;
      this.scrollTop = $('html,body').scrollTop();
      $('html,body').css('overflow', 'hidden');
    }
  }
};
</script>

<style>
.c-rulebox-w {
  position: fixed;
  z-index: 2;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
}
.c-rulebox {
  transform: translate(-50%, -50%);
  position: absolute;
  top: 50%;
  left: 50%;
  width: 3.11rem;
  padding: 0.24rem 0 0.16rem;
  background: #fff;
  border-radius: 0.08rem;
}
.c-rulebox__tit {
  text-align: center;
  font-size: 0.16rem;
  margin-bottom: 0.08rem;
}
.c-rulebox__content {
  color: #666;
  font-size: 0.13rem;
  line-height: 0.2rem;
  white-space: pre-wrap;
  padding: 0 0.3rem;
  max-height: 2.2rem;
  overflow: auto;
}
.c-rulebox__btn {
  width: 2.79rem;
  height: 0.44rem;
  line-height: 0.44rem;
  background: rgba(13, 203, 184, 1);
  border-radius: 0.04rem;
  color: #fff;
  font-size: 0.17rem;
  text-align: center;
  margin: 0.14rem auto 0;
}
</style>
